import { HttpErrorResponse } from '@angular/common/http';

export class ErrorResponse {
  error: {
    code: string;
    message: string;
  };
}

export class ErrorNodeJsResponse {
  error: string;
  detail: string;
}

export class ApiQueryParams {
  order?: any;
  filter?: any;
  navParams?: any;
  select?: any;
  limit?: number;
  offset?: number;
  q?: string;
}

export class RestService {
  public handleError(err: ErrorResponse | HttpErrorResponse | Error) {
    let logErr: {
      code: string;
      message: string;
    };
    let logErrMsg: string;

    if (err instanceof HttpErrorResponse) {
      const errObject: any = err.error;
      logErrMsg = `${err.status} - ${err.statusText || ''}`;
      if (typeof errObject.error === 'string') {
        logErr = {
          code: errObject.error,
          message: errObject.detail
        };
        logErrMsg += ` ${errObject.detail}`;
      } else {
        logErr = errObject.error;
        logErrMsg += ` ${errObject.error.message}`;
      }
    } else if (err instanceof ErrorResponse) {
      logErrMsg = err.error.code + ' ' + err.error.message;
      logErr = err.error;
    } else if (err instanceof ErrorNodeJsResponse) {
      logErrMsg = err.error + ' ' + err.detail;
      logErr = {
        code: err.error,
        message: err.detail
      };
    } else {
      logErrMsg = err.message ? err.message : err.toString();
      logErr = {
        code: 'unknown',
        message: err.message ? err.message : err.toString()
       };
    }

    console.error(logErrMsg);

    throw logErr;
  }
}
